module.exports = __webpack_public_path__ + "static/media/img4.522cf4b0.svg";